module.exports = __webpack_public_path__ + "static/media/logo.50a5567d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.png
// module id = 398
// module chunks = 0